export default "__VITE_ASSET__F32HwF1y__"